import { IMAGE_ALIGNS } from '@api/constants';
import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';
import { TEXT_COLOURS, BRANDED_COLOURS, OREGON_COLOURS, GRADIENTS, SPIKES_COLOURS, WA_TRANSPARANT } from '@constants';

export const FORM_FIELD = {
  ARTICLE: {
    name: 'article',
    label: 'Find the page you want to feature:',
    rules: [{ required: true, message: 'This field is required' }],
    serialize: utils.relatedEntitySerializerForContentIdOrId,
  },
  IMAGE: {
    name: 'image',
    label: 'Page image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['1000x600'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Write a title',
    rules: [{ required: true, message: 'Title is required' }],
  },
  SUBTITLE: {
    name: 'subtitle',
    label: 'Subtitle:',
    placeholder: 'Write a subtitle',
    rules: [{ required: true, message: 'Subtitle is required' }],
  },
  DESCRIPTION: {
    name: 'description',
    label: 'Description:',
    placeholder: 'Enter a description',
    rules: [{ required: true, message: 'Description is required' }],
  },
  URL_TEXT: {
    name: 'urlText',
    label: 'URL Text:',
    placeholder: 'Enter the text that redirects to URL',
  },
  URL: {
    name: 'url',
    label: 'URL:',
    placeholder: 'Enter the page URL',
    rules: [
      { required: true, message: 'URL is required' },
      { type: 'url', message: "Doesn't look like a valid URL" },
    ],
  },
  IMAGE_POSITION: {
    name: 'imagePosition',
    label: 'Image position:',
    positions: IMAGE_ALIGNS,
    rules: [{ required: true }],
  },
  BACKGROUND_COLOR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [
      WA_TRANSPARANT,
      ...BRANDED_COLOURS,
      ...OREGON_COLOURS,
      ...TEXT_COLOURS,
      ...SPIKES_COLOURS,
      GRADIENTS['gradient-1'].key,
    ],
    rules: [{ required: true }],
  },
};
export const FORM_FIELDS = Object.values(FORM_FIELD);

export const MODE = {
  MANUALLY: {
    value: 'manually',
    label: 'Manually',
  },
  EXISTING: {
    value: 'existing',
    label: 'An existing article',
  },
};
export const MODES = Object.values(MODE);

export const INITIAL_VALUES = {
  [FORM_FIELD.BACKGROUND_COLOR.name]: FORM_FIELD.BACKGROUND_COLOR.colors[0],
  [FORM_FIELD.IMAGE_POSITION.name]: FORM_FIELD.IMAGE_POSITION.positions[0].key,
};
